import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { PurchaseOrderSidebarService } from "../../../../core/services/purchase-order-sidebar.service";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { GetExtisingPOIdRequest } from "../../../../core/models/orders/getExtisingPOIdRequest";
import { PurchaseOrderIdDto } from "../../../../core/models/orders/purchaseOrderIdDto";
import { DrawerModule } from "primeng/drawer";
import { FormsModule } from "@angular/forms";
import { SelectModule } from "primeng/select";

@UntilDestroy()
@Component({
  selector: "jni-purchase-order-sidebar",
  templateUrl: "./purchase-order-sidebar.component.html",
  styleUrls: ["./purchase-order-sidebar.component.scss"],
  imports: [DrawerModule, FormsModule, SelectModule],
})
export class PurchaseOrderSidebarComponent implements OnInit {
  @Input() saleOrderId = "";
  @Input() directDeliveryVendor = "";

  @Input() display!: boolean;
  @Output() displayChange = new EventEmitter<boolean>();
  @Output() purchaseOrderFormEvent = new EventEmitter<string>();

  purchaseOrderSelected = "";
  @Input() purchaseOrderIdList: PurchaseOrderIdDto[] = [];

  constructor(
    private _purchaseOrderSidebarService: PurchaseOrderSidebarService
  ) {}

  ngOnInit(): void {
    if (this.saleOrderId) {
      //this.getPurchaseOrderId(this.saleOrderId, this.directDeliveryVendor);
    }
  }

  onHide() {
    this.displayChange.emit(false);
  }

  getPurchaseOrderId(saleOrderId: string, directDeliveryVendor: string) {
    const purchaseOrder: GetExtisingPOIdRequest = {
      SaleOrderId: saleOrderId,
      DirectDeliveryVendor: directDeliveryVendor,
    };

    this._purchaseOrderSidebarService
      .GetExtisingPOId(purchaseOrder)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data) {
            if (res.data.PurchaseOrderIds) {
              this.purchaseOrderIdList = res.data.PurchaseOrderIds;
            }
          }
        },
      });
  }

  onSubmit() {
    this.purchaseOrderFormEvent.emit(this.purchaseOrderSelected);
  }
}
